import { TApplicationState } from 'shared/types/redux';

export const selectFormPriceRange = (state: TApplicationState): [number, number] => {
  return state.formStatus.priceRange;
};
